import { diContainer } from '../../libs/container';

interface IRequestState {
    abortController: AbortController;
}

export class AbortStateHandlerClass {
    private requestStateMap = new Map<string, IRequestState>();

    public getRequestState(key: string) {
        return this.requestStateMap.get(key);
    }

    public abortExistingRequest(key: string) {
        const requestState = this.requestStateMap.get(key);
        if (requestState) {
            requestState.abortController.abort();
            this.requestStateMap.delete(key);
        }
    }

    public setRequestState(key: string, requestState: IRequestState) {
        this.requestStateMap.set(key, requestState);
    }

    public deleteRequestState(key: string) {
        const requestState = this.getRequestState(key);
        if (requestState) {
            this.requestStateMap.delete(key);
        }
    }
}

diContainer.bindAsConstant(AbortStateHandlerClass, new AbortStateHandlerClass());
